import { NgModule } from '@angular/core';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { IonicPageModule } from 'ionic-angular';
import { HeaderComponent } from './header/header.component';
import { StatusWordingPipe } from '../shared/pipes/statusWording.pipe';
import { ByProductIdPipe } from '../shared/pipes/byProductId.pipe';
import { StatusClassPipe } from '../shared/pipes/statusClass.pipe';
import { ToShortDatePipe } from '../shared/pipes/toShortDate.pipe';
import { ImagePipe } from '../shared/pipes/images.pipe';
import { EscapeDataPipe } from '../shared/pipes/keepData.pipe';
import { FirstLetterPipe } from '../shared/pipes/firstLetter.pipe';
import { AmountConverterPipe } from '../shared/pipes/amountConverter.pipe';
import { ToAgePipe } from '../shared/pipes/toAge.pipe';
import { MaskIbanPipe } from '../shared/pipes/maskIban.pipe';
import { InformationComponent } from './information/information.component';
import { ActionNavButtonsComponent } from './action-nav-buttons/action-nav-buttons.component';
import { SharedModule, SondageReponseService, SondageService } from '../shared';
import { ImgComponent } from './img/img.component';
import { BlogArticleListComponent } from './blog-article-list/blog-article-list.component';
import { OrderNoteComponent } from './order/note/order-note.component';
import { PaymentComponent } from './payment/payment.component';
import { FolderAction } from './payment/actions/folder.action';
import { OrderAction } from './payment/actions/order.action';
import { FormFolderLineComponent } from './form-folder-line/form-folder-line.component';
import { FileSelectorComponent } from './file-selector/file-selector.component';
import { AppProvider } from './app/app-provider.service';
import { EnvironnementProvider } from './app/environnement-provider.service';
import { TelPipe } from '../shared/pipes/tel.pipe';
import { SondageListComponent } from './sondage-list/sondage-list.component';
import { ChartsModule } from 'ng2-charts';
import { ModeleEcheancierService } from '../shared/services/modeleEcheancier.service';
import { Chooser } from '@ionic-native/chooser';
import { ReduccePaymentLoaderComponent } from './reducce-payment-loader/reducce-payment-loader.component';
import { ReduccePaymentService } from '../shared/services/reducce-payment.service';
import { CgvModalComponent } from './cgv-modal/cgv-modal.component';
import { SousGenreTopModalComponent } from './sous-genre-top-modal/sous-genre-top-modal.component';
import { SensMontantPipe } from '../shared/pipes/sensMontant.pipe';
import { SensPaiementPipe } from '../shared/pipes/sensPaiement.pipe';
import { ProduitsService } from '../shared/services/produits.service';
import { PopoverFilters } from "../pages/search/popover-filters/popover-filters";
import { FooterComponent } from "./footer/footer.component";
import { MenuService } from '../shared/services/menu.service';

@NgModule({
  imports: [
    IonicPageModule,
    SharedModule,
    ChartsModule,
  ],
  declarations: [
    MainMenuComponent,
    FormErrorComponent,
    InformationComponent,
    HeaderComponent,
    FooterComponent,
    StatusWordingPipe,
    AmountConverterPipe,
    ByProductIdPipe,
    StatusClassPipe,
    ToShortDatePipe,
    ToAgePipe,
    FirstLetterPipe,
    ImagePipe,
    EscapeDataPipe,
    TelPipe,
    SensMontantPipe,
    MaskIbanPipe,
    ActionNavButtonsComponent,
    ImgComponent,
    BlogArticleListComponent,
    OrderNoteComponent,
    PaymentComponent,
    FormFolderLineComponent,
    FileSelectorComponent,
    SondageListComponent,
    ReduccePaymentLoaderComponent,
    CgvModalComponent,
    SousGenreTopModalComponent,
    PopoverFilters,
    SensPaiementPipe,
  ],
  exports: [
    MainMenuComponent,
    FormErrorComponent,
    InformationComponent,
    HeaderComponent,
    FooterComponent,
    StatusWordingPipe,
    AmountConverterPipe,
    ByProductIdPipe,
    StatusClassPipe,
    ToShortDatePipe,
    ToAgePipe,
    FirstLetterPipe,
    ImagePipe,
    EscapeDataPipe,
    TelPipe,
    SensMontantPipe,
    MaskIbanPipe,
    ActionNavButtonsComponent,
    ImgComponent,
    BlogArticleListComponent,
    OrderNoteComponent,
    PaymentComponent,
    FormFolderLineComponent,
    FileSelectorComponent,
    SondageListComponent,
    ReduccePaymentLoaderComponent,
    CgvModalComponent,
    SousGenreTopModalComponent,
    SensPaiementPipe,
  ],
  providers: [
    FolderAction,
    OrderAction,
    AppProvider,
    EnvironnementProvider,
    SondageService,
    SondageReponseService,
    ModeleEcheancierService,
    Chooser,
    ProduitsService,
    MenuService,
  ],
  entryComponents: [
    ReduccePaymentLoaderComponent,
    CgvModalComponent,
    SousGenreTopModalComponent,
    PopoverFilters
  ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/core/core.module.ts